export default __webpack_public_path__ + "static/media/earth.7888338e.png";